import peiTypes from '@/utils/constants/peiTypes';

export default Object.freeze([
  {
    id: 4,
    name: peiTypes.INITIAL,
  },
  {
    id: 5,
    name: peiTypes.REVISION,
  },
  {
    id: 6,
    name: peiTypes.AMENDMENT,
  },
]);